<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import Checkbox from "../../atoms/forms/Checkbox.svelte";
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let id = 0;
  let from = "";
  let host = "";
  let port = "465";
  let username = "";
  let password = "";
  let secure = false;
  let loading = false;

  const handleFrom = (event) => {
    from = event.detail.value;
  };

  const handleHost = (event) => {
    host = event.detail.value;
  };

  const handlePort = (event) => {
    port = event.detail.value;
  };

  const handleUsername = (event) => {
    username = event.detail.value;
  };

  const handlePassword = (event) => {
    password = event.detail.value;
  };

  const handleSecure = (event) => {
    secure = event.detail.value;
  };

  const save = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/mail/sendSetting", {
      mailType: "inquiry",
      from,
      host,
      port,
      username,
      password,
      secure,
    });
    console.log(data);
    loading = false;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/mail/sendSetting?mailType=inquiry");
    if (!data.mailSendSetting) {
      return;
    }
    from = data.mailSendSetting.from;
    id = data.mailSendSetting.id;
    host = data.mailSendSetting.host;
    username = data.mailSendSetting.username;
    password = data.mailSendSetting.password;
    port = data.mailSendSetting.port;
    secure = data.mailSendSetting.secure;
  });
</script>

<SectionBoard>
  <h2 class="font-semibold">お問い合わせ(送信設定)</h2>

  <div class="mt-6">
    <FormWithLabel
      label="送信メールアドレス"
      placeholder="from@example.com"
      input={handleFrom}
      value={from}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="SMTPホスト"
      placeholder="smto.example.com"
      input={handleHost}
      value={host}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="SMTPポート"
      placeholder="465"
      input={handlePort}
      inputType="number"
      value={port}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="認証ユーザー"
      placeholder="info@example.com"
      input={handleUsername}
      inputType="text"
      value={username}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="認証パスワード"
      placeholder="password"
      input={handlePassword}
      inputType="password"
      value={password}
    />
  </div>

  <div class="mt-6">
    <Checkbox label="SSL" on:click={handleSecure} checked={secure} />
  </div>

  <BlueButton rounded klass="mt-4" click={save} {loading}>更新する</BlueButton>
</SectionBoard>
